<template>
  <div v-if="authDevices !== null">
    <v-fade-transition>
      <v-layout
        v-show="!readOnly && selected.length > 0"
        row
      >
        <v-spacer />
        <v-btn
          flat
          class="text-secondary"
          @click="deleteDialog=true"
        >
          <v-icon
            class="mr-1"
            icon="mdi-delete"
            color="secondary"
          />
          {{ $t('DeleteSelectedItems') }}
        </v-btn>
      </v-layout>
    </v-fade-transition>
    <v-data-table
      v-model="selected"
      :items="authDevices"
      :headers="headers"
      item-value="id"
      :show-select="!readOnly"
      :items-per-page-text="$t('DataTable.RowsPerPage')"
    >
      <!-- header's checkbox -->
      <template #header.data-table-select="{ allSelected, selectAll, someSelected }">
        <v-checkbox-btn
          class="ml-2"
          :indeterminate="someSelected && !allSelected"
          :model-value="allSelected"
          color="secondary"
          @update:model-value="selectAll(!allSelected)"
        />
      </template>

      <!-- data -->
      <template #item="props">
        <tr :class="{'highlighted-row': props.item.session_id === currentSessionId}">
          <td v-if="!readOnly">
            <v-checkbox-btn
              :model-value="props.isSelected(props.internalItem)"
              color="secondary"
              hide-details
              @update:model-value="props.toggleSelect(props.internalItem)"
            />
          </td>
          <td>
            {{ props.item.user_agent }}
          </td>
          <td>
            {{ props.item.from_host }}&nbsp;({{ props.item.from_ipaddress }})
          </td>
          <td>
            {{ $filters.calendar(props.item.created_at_unix) }}
          </td>
          <td>
            {{ $filters.calendar(props.item.exp_unix) }}
          </td>
        </tr>
      </template>

      <template #item.from_host="{ item, value }">
        <p :class="{'font-weight-bold': item.is_now_session}">
          {{ value }} ({{ item.from_ipaddress }})
        </p>
      </template>
      <template #item.created_at_unix="{ item, value }">
        <p :class="{'font-weight-bold': item.is_now_session}">
          {{ $filters.calendar(value) }}
        </p>
      </template>

      <template #no-data>
        <v-row class="text-grey justify-center">
          {{ $t('NoItems') }}
        </v-row>
      </template>
    </v-data-table>

    <!-- 削除ダイアログ -->
    <DeleteDialog
      v-model="deleteDialog"
      :api-address="'user-auth-devices/' + userId + '/'"
      :api-data="{auth_devices: convertList(selected)}"
      @reload="get()"
    >
      {{ $t('AuthDevice.DeleteInfo') }}
    </DeleteDialog>
  </div>
  <div
    v-else
    class="pa-3"
  >
    ...
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import DeleteDialog from '../dialogs/DeleteDialog'
  import moment from 'moment/moment'

  export default {
    components: { DeleteDialog },
    props: {
      userId: {
        type: String,
        required: true
      }
    },
    data: () => ({
      authDevices: null,
      headers: [],
      readOnly: true,
      selected: [],
      deleteDialog: false,
      currentSessionId: localStorage.getItem('session_id') || null
    }),
    computed: {
      ...mapGetters(['ui', 'login']),
      moment () {
        return moment
      }
    },
    created () {
      this.headers = [
        { title: this.$t('AuthDevice.Device'), key: 'user_agent' },
        { title: this.$t('AuthDevice.AccessFrom'), key: 'from_host' },
        { title: this.$t('AuthDevice.LoginDate'), key: 'created_at_unix' },
        { title: this.$t('AuthDevice.ExpirationDate'), key: 'exp' }
      ]
      this.get()
    },
    methods: {
      get () {
        this.selected = []
        this.$http.get(`user-auth-devices/${this.userId}/`).then((res) => {
          this.authDevices = res.data.auth_devices
          // 変更権限有無判定（自分のもの、もしくはAdmin）
          if (this.login.profile.id === this.userId || this.login.profile.is_admin === true) {
            this.readOnly = false
          }
        })
      },
      convertList (target) {
        let ret = []
        for (let k of Object.keys(target)) {
          ret.push(target[k])
        }
        return ret
      }
    }
  }
</script>

<style scoped>
  .highlighted-row {
    background-color: rgba(41, 169, 207, 0.3);
  }
</style>

<style scoped>

</style>
